module.exports = __webpack_public_path__ + "img/189.6da47d38.jpg";